import React, { useState, useEffect } from "react";
import { Modal, Header, Button, Dropdown, Table } from "semantic-ui-react";
import {
  GetBookByPeriod,
  DownloadBook,
  DownloadDocuments,
  RCVPeriods,
} from "../../../../../graphql/documents";
import { formatMoney } from "../../../../../utils/formatter";
import { documentsDic } from "../../../../../utils/dataDictionary";
import { useDispatch, useSelector } from "react-redux";
import { importOpenSidebar } from "../../../../../redux/actions/openSidebar";
import LoadingSpinner from "../../spinnerLoading";
import moment from "moment";
import "./style.scss";

const DescargarLibro = ({ openSidebar, trigger }) => {
  const dispatch = useDispatch();
  const [period, setPeriod] = useState();
  const [totals, setTotals] = useState({});
  const [docs, setDocs] = useState([]);
  const [options, setOptions] = useState([]);

  const {
    selectedCompany: { name, rut, id: companyId },
  } = useSelector((state) => state.companyList);
  const {
    documentsFilter = {},
  } = useSelector((state) => state.documentostributarios);

  const { data, fetching, executeMutation } = GetBookByPeriod();
  const { fetching: excelFetching, executeMutation: downloadBook } = DownloadBook();
  const { executeMutation: downloadDocuments, fetching: downloadAllFetching } = DownloadDocuments();
  const { executeMutation: getPeriods } = RCVPeriods();

  const selected = openSidebar.editData?.selected;
  const documentType = openSidebar.editData?.documentType

  useEffect(async () => {
    if (selected) {
      const periods = await getPeriods({ companyId, type: selected });
      const availablePeriods = periods?.data?.getPeriodsAvailable?.map((p) => {
        const text = moment(p, "YYYYMM").format("MMMM YYYY");

        return { key: p, value: p, text };
      });

      setOptions(availablePeriods);
    }
  }, [selected]);

  useEffect(async () => {
    if (period) {
      const isReceived = selected == "RECEIVED" || selected == "ALL";
      await executeMutation({ companyId, isReceived, isBoleta: selected == "FEES", period, documentType });
    }
  }, [period, companyId, selected]);

  useEffect(() => {
    if (data) {
      const idList = [];
      const summarized = data.getRCVBook.data.reduce((acc, el) => {
        if (!acc) acc = {};
        const determent = [61, "61", 112, "112"].includes(el.documentCode)
          ? -1
          : 1;
        acc["amount"] = (acc["amount"] || 0) + (el.amount || 0) * determent;
        acc["taxAmount"] =
          (acc["taxAmount"] || 0) + (el.taxAmount || 0) * determent;
        acc["nonTaxableAmount"] =
          (acc["nonTaxableAmount"] || 0) +
          (el.nonTaxableAmount || 0) * determent;
        acc["taxableAmount"] =
          (acc["taxableAmount"] || 0) + (el.taxableAmount || 0) * determent;
        acc["lateTaxes"] =
          (acc["lateTaxes"] || 0) + (el.lateTaxes || 0) * determent;
        idList.push(el["_id"]);
        return acc;
      }, {});

      setTotals(summarized);
      setDocs(idList);
    }
  }, [data]);

  if (!selected) return trigger;

  const onClose = () => {
    dispatch(importOpenSidebar({ show: false, downloadBook: false }));
    setDocs([]);
  };

  const downloadAll = async () => {
    const response = await downloadDocuments(
      {
        input: {
          companyId,
          documentTypes: ["TAX_DOCUMENT", "OBLIGATION"],
          newFilter: documentsFilter,
        },
      },
      { requestPolicy: "network-only" }
    )

    if (!response?.error) {
      const URL = response.data.downloadDocuments
      if (URL) window.open(URL);
    }

    //return dispatch(importOpenSidebar({ show: false, downloadBook: false }));
  }

  const onDownload = async () => {
    if (selected !== 'ALL') {
      const response = await downloadBook({
        companyId,
        type: selected,
        period,
        ids: docs,
      });

      if (!response.error) {
        if (response.data.downloadRCVBook)
          window.open(response.data.downloadRCVBook);
      }
    }
  };

  const type = {
    GIVEN: "LIBRO DE VENTAS",
    RECEIVED: "LIBRO DE COMPRAS",
    FEES: "HONORARIOS"
  };

  const time = (selectedPeriod) => {
    if (selectedPeriod) {
      const year = selectedPeriod.substring(0, 4);
      const month = selectedPeriod.substring(4, 6);

      const fecha = moment(`${month}/01/${year}`).format("MMMM YYYY");

      return fecha;
    }

    return "";
  };

  const Headers = [
    { key: "id", label: "N°" },
    { key: "documentDate", label: "Fecha" },
    { key: "summary", label: "Tipo de Doc." },
    { key: "documentId", label: "Folio" },
    { key: "name", label: "Contraparte" },
    { key: "rut", label: "RUT" },
    { key: "exemptAmount", label: "Monto Exento" },
    { key: "affectAmount", label: "Monto Afecto" },
    { key: "taxAmount", label: selected == "FEES" ? "Retención" : "IVA" },
    { key: "lateTaxes", label: "IVA Fuera de Plazo" },
    { key: "amount", label: "Monto Total" },
  ].filter(f => {
    if (selected == 'FEES' && f.key == 'lateTaxes') return false
    return true
  });

  const ResumenHeaders = [
    { key: "documentType", label: "Tipo de Documento" },
    { key: "documentCode", label: "Cod. SII" },
    { key: "quantity", label: "Cantidad" },
    { key: "exceptAmount", label: "Monto Exento" },
    { key: "affectAmount", label: "Monto Afecto" },
    { key: "taxAmount", label: selected == "FEES" ? "Retención" : "IVA" },
    { key: "lateTaxes", label: "IVA Fuera de Plazo" },
    { key: "amount", label: "Monto Total" },
  ].filter(f => {
    if (selected == 'FEES' && f.key == 'lateTaxes') return false
    return true
  });

  const PeriodSelection = (
    <div className="periodSelection">
      <Header>Seleccionar período: </Header>
      <Dropdown
        selectOnBlur={false}
        placeholder="Período"
        fluid
        search
        selection
        className="periodDropDown"
        onChange={(_, v) => setPeriod(v.value)}
        options={options}
      />
    </div>
  );

  const DownloadAllDocuments = (
    <>
      <Header>Todos los documentos:</Header>
      <div className="d-flex justify-content-center">
        <Button onClick={downloadAll} loading={downloadAllFetching} color="blue">Descargar</Button>
      </div>
    </>
  );

  const RCVTable = (
    <div className="rcvContainer">
      <div className="d-flex w-100 rcvHeader">
        <div className="d-flex flex-column rcvInfo">
          <div className="text-uppercase rcvName">{name}</div>
          <div className="text-uppercase rcvName">{rut}</div>
        </div>
        <div className="text-uppercase font-weight-bold rcvTitle">{`${type[openSidebar.editData.selected] || "Libro"
          } ${time(period)}`}</div>
        <div className="rcvOther"></div>
      </div>
      <div className="mt-4 rcvTable">
        <Table columns={10} celled>
          <div
            style={{ overflowY: "scroll", width: "100%", maxHeight: "35vh" }}
          >
            <Table.Header>
              <Table.Row>
                {Headers.map((header) => (
                  <Table.HeaderCell textAlign="center">
                    {header.label}
                  </Table.HeaderCell>
                ))}
              </Table.Row>
            </Table.Header>

            <Table.Body>
              {data &&
                data.getRCVBook.data.map((row, index) => (
                  <Table.Row>
                    <Table.Cell textAlign="center" width={1}>
                      {index + 1}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
                      {moment(row.documentDate).format("DD-MM-YYYY")}
                    </Table.Cell>
                    <Table.Cell width={4}>
                      {documentsDic[parseInt(row.documentCode)].fullName ||
                        row.summary}
                    </Table.Cell>
                    <Table.Cell>{row.documentId}</Table.Cell>
                    <Table.Cell width={6}>
                      {row.isReceived ? row.issuerName : row.receiverName}
                    </Table.Cell>
                    <Table.Cell>
                      {row.isReceived ? row.issuerId : row.receiverId}
                    </Table.Cell>
                    <Table.Cell width={3} textAlign="right">
                      {formatMoney(row?.nonTaxableAmount || 0) || 0}
                    </Table.Cell>
                    <Table.Cell width={3} textAlign="right">
                      {formatMoney(row?.taxableAmount || 0) || 0}
                    </Table.Cell>
                    <Table.Cell width={3} textAlign="right">
                      {formatMoney(row.taxAmount || 0) || 0}
                    </Table.Cell>
                    {selected !== 'FEES' && <Table.Cell width={3} textAlign="right">
                      {formatMoney(row.lateTaxes || 0) || 0}
                    </Table.Cell>}
                    <Table.Cell width={selected == 'FEES' ? 6 : 3} textAlign="right">
                      {formatMoney(row.amount || 0) || 0}
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
            <Table.Footer>
              <Table.Row>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell></Table.HeaderCell>
                <Table.HeaderCell>Totales</Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {formatMoney(totals?.nonTaxableAmount || 0) || 0}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {formatMoney(totals?.taxableAmount || 0) || 0}
                </Table.HeaderCell>
                <Table.HeaderCell textAlign="right">
                  {formatMoney(totals?.taxAmount || 0) || 0}
                </Table.HeaderCell>
                {selected !== 'FEES' && <Table.HeaderCell textAlign="right">
                  {formatMoney(totals?.lateTaxes || 0) || 0}
                </Table.HeaderCell>}
                <Table.HeaderCell textAlign="right">
                  {formatMoney(totals?.amount || 0) || 0}
                </Table.HeaderCell>
                <Table.HeaderCell />
              </Table.Row>
            </Table.Footer>
          </div>
        </Table>
      </div>
      <div className="mt-5 rcvResumen">
        <Table size="small" celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>RESUMEN GENERAL</Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              {ResumenHeaders.map((resumenHeader) => (
                <Table.HeaderCell textAlign="center">
                  {resumenHeader.label}
                </Table.HeaderCell>
              ))}
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {data &&
              data.getRCVBook.resume.map((row, index) => (
                <Table.Row>
                  <Table.Cell width={6}>
                    {documentsDic[parseInt(row._id)]?.fullName || row.summary}
                  </Table.Cell>
                  <Table.Cell textAlign="center">{row._id}</Table.Cell>
                  <Table.Cell textAlign="center">{row.count}</Table.Cell>
                  <Table.Cell textAlign="right">
                    {formatMoney(row.nonTaxableAmount || 0) || 0}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {formatMoney(row.taxableAmount || 0) || 0}
                  </Table.Cell>
                  <Table.Cell textAlign="right">
                    {formatMoney(row.taxAmount || 0) || 0}
                  </Table.Cell>
                  {selected !== 'FEES' && <Table.Cell textAlign="right">
                    {formatMoney(row.lateTaxes || 0) || 0}
                  </Table.Cell>}
                  <Table.Cell textAlign="right">
                    {formatMoney(row.amount || 0) || 0}
                  </Table.Cell>
                </Table.Row>
              ))}
          </Table.Body>
        </Table>
      </div>
    </div>
  );

  const header =
    selected == 'ALL'
      ? 'Descarga'
      : documentType == "OBLIGATION" ? "Descargar Obligaciones"
        : selected == "FEES" ? "Descargar Registro de Honorarios"
          : `Descargar Libro de ${selected == "RECEIVED" ? "Compras" : "Ventas"}`

  return (
    <Modal
      open={openSidebar?.downloadBook}
      size={data && period ? "fullscreen" : "mini"}
      className={data && period ? "downloadBookModal" : ""}
      dimmer="blurring"
      closeIcon={true}
      onClose={onClose}
      trigger={trigger}
    >
      <Modal.Header>{header}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          {fetching && !data ? (
            <div className="d-flex justify-content-center align-items-center w-100">
              <LoadingSpinner
                height="40px"
                afterHeight="40px"
                afterWidth="40px"
              />
            </div>
          ) : period && data && selected !== 'ALL' ? (
            RCVTable
          ) : selected == 'ALL' ? (DownloadAllDocuments) : (
            documentType == "OBLIGATION" ? "Descargar obligaciones aún no está disponible." : PeriodSelection
          )}
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions className="d-flex justify-content-between">
        <div>
          <Button hidden={!period} onClick={() => setPeriod()}>
            Volver
          </Button>
        </div>
        <div>
          <Button
            color="blue"
            className="mr-4"
            hidden={!period && !data}
            onClick={onDownload}
            loading={excelFetching}
          >
            Descargar
          </Button>
          <Button onClick={onClose}>
            Cerrar
          </Button>
        </div>
      </Modal.Actions>
    </Modal>
  );
};

export default DescargarLibro;
